// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BaggersRouteImport } from './routes/baggers'
import { Route as KoRouteImport } from './routes/ko'
import { Route as LearnRouteImport } from './routes/learn'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as ReferralsRouteImport } from './routes/referrals'
import { Route as SignRouteImport } from './routes/sign'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as KoIndexRouteImport } from './routes/ko.index'
import { Route as KoLearnRouteImport } from './routes/ko.learn'
import { Route as LearnIndexRouteImport } from './routes/learn.index'
import { Route as LearnSlugRouteImport } from './routes/learn.$slug'
import { Route as RCodeRouteImport } from './routes/r.$code'
import { Route as TradeIndexRouteImport } from './routes/trade.index'
import { Route as TradeSymbolRouteImport } from './routes/trade.$symbol'
import { Route as KoLearnIndexRouteImport } from './routes/ko.learn.index'
import { Route as KoLearnSlugRouteImport } from './routes/ko.learn.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BaggersRoute = BaggersRouteImport.update({
            id: '/baggers',path: '/baggers',getParentRoute: () => rootRouteImport
          })
const KoRoute = KoRouteImport.update({
            id: '/ko',path: '/ko',getParentRoute: () => rootRouteImport
          })
const LearnRoute = LearnRouteImport.update({
            id: '/learn',path: '/learn',getParentRoute: () => rootRouteImport
          })
const PortfolioRoute = PortfolioRouteImport.update({
            id: '/portfolio',path: '/portfolio',getParentRoute: () => rootRouteImport
          })
const ReferralsRoute = ReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => rootRouteImport
          })
const SignRoute = SignRouteImport.update({
            id: '/sign',path: '/sign',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const KoIndexRoute = KoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => KoRoute
          })
const KoLearnRoute = KoLearnRouteImport.update({
            id: '/learn',path: '/learn',getParentRoute: () => KoRoute
          })
const LearnIndexRoute = LearnIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LearnRoute
          })
const LearnSlugRoute = LearnSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => LearnRoute
          })
const RCodeRoute = RCodeRouteImport.update({
            id: '/r/$code',path: '/r/$code',getParentRoute: () => rootRouteImport
          })
const TradeIndexRoute = TradeIndexRouteImport.update({
            id: '/trade/',path: '/trade/',getParentRoute: () => rootRouteImport
          })
const TradeSymbolRoute = TradeSymbolRouteImport.update({
            id: '/trade/$symbol',path: '/trade/$symbol',getParentRoute: () => rootRouteImport
          })
const KoLearnIndexRoute = KoLearnIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => KoLearnRoute
          })
const KoLearnSlugRoute = KoLearnSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => KoLearnRoute
          })





const KoLearnRouteChildren = {
  KoLearnSlugRoute: KoLearnSlugRoute,KoLearnIndexRoute: KoLearnIndexRoute
}

const KoLearnRouteWithChildren = KoLearnRoute._addFileChildren(KoLearnRouteChildren)



const KoRouteChildren = {
  KoLearnRoute: KoLearnRouteWithChildren,KoIndexRoute: KoIndexRoute
}

const KoRouteWithChildren = KoRoute._addFileChildren(KoRouteChildren)




const LearnRouteChildren = {
  LearnSlugRoute: LearnSlugRoute,LearnIndexRoute: LearnIndexRoute
}

const LearnRouteWithChildren = LearnRoute._addFileChildren(LearnRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,BaggersRoute: BaggersRoute,KoRoute: KoRouteWithChildren,LearnRoute: LearnRouteWithChildren,PortfolioRoute: PortfolioRoute,ReferralsRoute: ReferralsRoute,SignRoute: SignRoute,TermsRoute: TermsRoute,RCodeRoute: RCodeRoute,TradeSymbolRoute: TradeSymbolRoute,TradeIndexRoute: TradeIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)